import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import de from "./de";
import it from "./it";
import fr from "./fr";

const savedLang = localStorage.getItem("probook_lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    it: { translation: it },
    fr: { translation: fr },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("probook_lang", lng);
});

export default i18n;
